/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { ChartSkeletalLoader } from "../chart_skeletal_loader";
import { AssociatedRestaurantItemCard } from "./restaurant_card";
import {
  AssociatedRestaurantCard,
  AssociatedRestaurantCardsList,
  AssociatedRestaurantHeader,
  AssociatedRestaurantHeading,
  AssociatedRestaurantHeadingCount,
  AssociatedRestaurantLoaderWrap,
  AssociatedRestaurantEmptyState,
} from "./styles";

export const GuestAssociatedRestaurants = ({ associatedRestaurants, isLoading }) => {
  const associations = associatedRestaurants?.association_data || [];

  return (
    <AssociatedRestaurantCard data-testid="guest-associated-restaurants-section">
      <AssociatedRestaurantHeader>
        <AssociatedRestaurantHeading>
          ASSOCIATED RESTAURANTS
        </AssociatedRestaurantHeading>
        <AssociatedRestaurantHeadingCount data-testid="guest-associated-restaurants-count">
          {associations.length}
        </AssociatedRestaurantHeadingCount>
      </AssociatedRestaurantHeader>

      {isLoading ? (
        <AssociatedRestaurantLoaderWrap>
          <ChartSkeletalLoader dataTestId="guest-associated-restaurants-loader" />
        </AssociatedRestaurantLoaderWrap>
      ) : associations.length ? (
        <AssociatedRestaurantCardsList data-testid="guest-associated-restaurants-list">
          {associations.map((association, index) => (
            <AssociatedRestaurantItemCard
              key={association?.restaurant_id || `${association?.restaurant_name}-${index}`}
              association={association}
            />
          ))}
        </AssociatedRestaurantCardsList>
      ) : (
        <AssociatedRestaurantEmptyState data-testid="guest-associated-restaurants-empty-state">
          No associated restaurants found.
        </AssociatedRestaurantEmptyState>
      )}
    </AssociatedRestaurantCard>
  );
};
